import { NAnalysisCalculator } from '../../../../../cms/analysis-calculator/analysis-calculator.component';
import { NModalLayoutRight } from '../../../../../common/modal/layout-right/modal-layout-right.component';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISizeName } from '@df/core/service/client';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { ProductViewCalculatorComponent } from '../product-view-calculator.component';

export namespace NProductViewCalculatorModal {
    export const BLOCK_ID = 'pdp-calculator-modal';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> { }

    export interface IBlockDataContent extends NAnalysisCalculator.IComponentData {
        modalTitle: string;
    }
}

@DfCmsModal({
    id: NProductViewCalculatorModal.BLOCK_ID,
    name: 'Product View Calculator Modal',
    position: (sizeName: ISizeName) => (sizeName === 'S' ? 'bottom' : 'right'),
    config: sizeName => ({
        ...NModalLayoutRight.getConfig(sizeName),
        width: NModalLayoutRight.getWidth(sizeName),
        height: sizeName === 'S' ? '85dvh' : '100dvh',
        position:
            sizeName === 'S'
                ? { bottom: '0' }
                : {
                    top: '0',
                    right: '0',
                    bottom: '0'
                },
        hasBackdrop: true
    }),
    autoCreate: true,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X']),
    prerenderAllowed: false
})
@ICmsComponent<ProductViewCalculatorModalComponent>({
    id: NProductViewCalculatorModal.BLOCK_ID,
    block: {
        url: NProductViewCalculatorModal.BLOCK_ID,
        autoload: 'bootstrap'
    },
    onDemandOnly: true,
    name: 'Product View Calculator',
    description: 'Product View Calculator',
    fields: [
        {
            key: 'modalTitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Modal title'
        },
        ...NAnalysisCalculator.getFields(true)
    ]
})
@Component({
    selector: 'product-view-calculator-modal',
    templateUrl: './product-view-calculator-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule, ProductViewCalculatorComponent]
})
export class ProductViewCalculatorModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NProductViewCalculatorModal.IBlockDataContent;

    private modalRef = inject(ModalRef<ProductViewCalculatorModalComponent>);

    private readonly modalData = inject(MODAL_DATA);

    protected productsIds: number[] = [];

    override ngOnInit(): void {
        super.ngOnInit();
        this.productsIds = [this.modalData];
    }

    protected close() {
        this.modalRef.close();
    }
}
